import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/hongyou/background_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { login as _login, logout, getInfo as _getInfo, refreshtoken } from '@/api/user';
import { getToken, setToken, removeToken } from '@/utils/auth';
import router, { resetRouter } from '@/router';
import { qrLoginAuth } from '@/api/wx/qrconnect';
var state = {
  token: getToken(),
  userName: '',
  nickName: '',
  avatar: '',
  introduction: '',
  roles: [],
  permissions: [],
  permisaction: [],
  user: {},
  uniqueId: 0,
  // 添加
  areaIds: []
};
var getters = {
  roles: function roles(state) {
    return state.roles;
  },
  user: function user(state) {
    return state.user;
  },
  permissions: function permissions(state) {
    return state.permissions;
  },
  permisaction: function permisaction(state) {
    return state.permisaction;
  }
};
var mutations = {
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_USERID: function SET_USERID(state, userId) {
    state.userId = userId;
  },
  SET_UNIQUEID: function SET_UNIQUEID(state, uniqueId) {
    state.uniqueId = uniqueId;
  },
  SET_INTRODUCTION: function SET_INTRODUCTION(state, introduction) {
    state.introduction = introduction;
  },
  SET_USERNAME: function SET_USERNAME(state, userName) {
    state.userName = userName;
  },
  SET_NICKNAME: function SET_NICKNAME(state, nickName) {
    state.nickName = nickName;
  },
  SET_DEPTID: function SET_DEPTID(state, deptId) {
    state.deptId = deptId;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    if (avatar.indexOf('http') !== -1) {
      state.avatar = avatar;
    } else {
      state.avatar = process.env.VUE_APP_BASE_API + avatar;
    }
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  },
  SET_PERMISSIONS: function SET_PERMISSIONS(state, permisaction) {
    state.permisaction = permisaction;
  },
  SET_USER: function SET_USER(state, user) {
    state.user = user;
  },
  SET_AREAIDS: function SET_AREAIDS(state, areaIds) {
    state.areaIds = areaIds;
  }
};
var actions = {
  // user login
  login: function login(_ref, userInfo) {
    var commit = _ref.commit;
    return new Promise(function (resolve, reject) {
      _login(userInfo).then(function (response) {
        var token = response.token;
        commit('SET_TOKEN', token);
        setToken(token);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  loginByQr: function loginByQr(_ref2, form) {
    var commit = _ref2.commit;
    return new Promise(function (resolve, reject) {
      qrLoginAuth(form).then(function (res) {
        var token = res.token;
        commit('SET_TOKEN', token);
        setToken(token);
        resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // get user info
  getInfo: function getInfo(_ref3) {
    var commit = _ref3.commit,
      dispatch = _ref3.dispatch,
      state = _ref3.state;
    return new Promise(function (resolve, reject) {
      _getInfo().then(function (response) {
        if (!response || !response.data) {
          commit('SET_TOKEN', '');
          removeToken();
          resolve();
        }
        var _response$data = response.data,
          roles = _response$data.roles,
          userName = _response$data.userName,
          nickName = _response$data.nickName,
          avatar = _response$data.avatar,
          introduction = _response$data.introduction,
          permissions = _response$data.permissions,
          uniqueId = _response$data.uniqueId,
          userId = _response$data.userId,
          deptId = _response$data.deptId,
          areaIds = _response$data.areaIds;
        // roles must be a non-empty(非空的) array
        if (!roles || roles.length <= 0) {
          reject('getInfo: roles must be a non-null array!');
        }
        console.log(permissions, '带我去核对');
        commit('SET_PERMISSIONS', permissions);
        commit('SET_ROLES', roles);
        commit('SET_USERNAME', userName);
        commit('SET_NICKNAME', nickName);
        commit('SET_AVATAR', avatar);
        commit('SET_INTRODUCTION', introduction);
        commit('SET_UNIQUEID', uniqueId);
        commit('SET_DEPTID', deptId);
        commit('SET_USERID', userId);
        commit('SET_USER', response.data);
        commit('SET_AREAIDS', areaIds);

        // ✅ 初始化 WebSocket 连接（登录成功后）
        dispatch('ws/initWebSocket', null, {
          root: true
        });
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 退出系统
  LogOut: function LogOut(_ref4) {
    var commit = _ref4.commit,
      dispatch = _ref4.dispatch,
      state = _ref4.state;
    return new Promise(function (resolve, reject) {
      var data = {
        userId: state.userId
      };
      // 结束
      logout(data).then(function () {
        // ✅ 关闭所有 WebSocket 连接
        dispatch('ws/destroyAllWS', null, {
          root: true
        });
        commit('SET_TOKEN', '');
        commit('SET_ROLES', []);
        commit('SET_PERMISSIONS', []);
        removeToken();
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 刷新token
  refreshToken: function refreshToken(_ref5) {
    var commit = _ref5.commit,
      state = _ref5.state;
    return new Promise(function (resolve, reject) {
      refreshtoken({
        token: state.token
      }).then(function (response) {
        var token = response.token;
        commit('SET_TOKEN', token);
        setToken(token);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // remove token
  resetToken: function resetToken(_ref6) {
    var commit = _ref6.commit;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', '');
      removeToken();
      resolve();
    });
  },
  // dynamically modify permissions
  changeRoles: function changeRoles(_ref7, role) {
    var commit = _ref7.commit,
      dispatch = _ref7.dispatch;
    return new Promise( /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve) {
        var token, _yield$dispatch, roles, accessRoutes;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              token = role + '-token';
              commit('SET_TOKEN', token);
              setToken(token);
              _context.next = 5;
              return dispatch('getInfo');
            case 5:
              _yield$dispatch = _context.sent;
              roles = _yield$dispatch.roles;
              resetRouter();

              // generate accessible routes map based on roles
              _context.next = 10;
              return dispatch('permission/generateRoutes', roles, {
                root: true
              });
            case 10:
              accessRoutes = _context.sent;
              // dynamically add accessible routes
              router.addRoutes(accessRoutes);

              // reset visited views and cached views
              dispatch('tagsView/delAllViews', null, {
                root: true
              });
              resolve();
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref8.apply(this, arguments);
      };
    }());
  }
};
export default {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
};